"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPLOYEES_ES = exports.EMPLOYEES_EN = exports.EMPLOYEES = void 0;
exports.EMPLOYEES = [
    {
        label: 'Até 2',
        value: '0-2',
    },
    {
        label: 'De 3 a 10',
        value: '3-10',
    },
    {
        label: 'De 11 a 50',
        value: '11-50',
    },
    {
        label: 'De 51 a 200',
        value: '51-200',
    },
    {
        label: 'De 201 a 500',
        value: '201-500',
    },
    {
        label: 'De 501 a 1000',
        value: '501-1000',
    },
    {
        label: 'De 1000 a 2000',
        value: '1000-2000',
    },
    {
        label: 'De 2000 a 5000',
        value: '2000-5000',
    },
    {
        label: 'Acima de 5000',
        value: '5000-',
    },
    {
        label: 'Não se aplica',
        value: null,
    },
];
exports.EMPLOYEES_EN = [
    {
        label: 'Up to 2',
        value: '0-2',
    },
    {
        label: 'From 3 to 10',
        value: '3-10',
    },
    {
        label: 'From 11 to 50',
        value: '11-50',
    },
    {
        label: 'From 51 to 200',
        value: '51-200',
    },
    {
        label: 'From 201 to 500',
        value: '201-500',
    },
    {
        label: 'From 501 to 1000',
        value: '501-1000',
    },
    {
        label: 'From 1000 to 2000',
        value: '1000-2000',
    },
    {
        label: 'From 2000 to 5000',
        value: '2000-5000',
    },
    {
        label: 'More than 5000',
        value: '5000-',
    },
    {
        label: 'Not applicable',
        value: null,
    },
];
exports.EMPLOYEES_ES = [
    {
        label: 'Hast 2',
        value: '0-2',
    },
    {
        label: 'De 3 a 10',
        value: '3-10',
    },
    {
        label: 'De 11 a 50',
        value: '11-50',
    },
    {
        label: 'De 51 a 200',
        value: '51-200',
    },
    {
        label: 'De 201 a 500',
        value: '201-500',
    },
    {
        label: 'De 501 a 1000',
        value: '501-1000',
    },
    {
        label: 'De 1000 a 2000',
        value: '1000-2000',
    },
    {
        label: 'De 2000 a 5000',
        value: '2000-5000',
    },
    {
        label: 'Más de 5000',
        value: '5000-',
    },
    {
        label: 'No se aplica',
        value: null,
    },
];
//# sourceMappingURL=employees.js.map